import React from 'react'

interface AccountPlaceholderTabProps {
  title: string
  description: string
  ticketRef?: string
}

export function AccountPlaceholderTab({ title, description, ticketRef }: AccountPlaceholderTabProps): React.ReactElement {
  return (
    <div className="flex flex-col items-center justify-center py-16">
      <svg className="w-12 h-12 text-slate-600 mb-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1}>
        <path strokeLinecap="round" strokeLinejoin="round" d="M11.42 15.17l-5.384 3.18a1.008 1.008 0 01-1.478-.868V5.57a1.008 1.008 0 011.478-.868l5.384 3.18m0 7.29V7.88m0 7.29l5.384 3.18a1.008 1.008 0 001.478-.868V5.57a1.008 1.008 0 00-1.478-.868l-5.384 3.18" />
      </svg>
      <h3 className="text-lg font-semibold text-white mb-2">{title}</h3>
      <p className="text-slate-400 text-sm text-center max-w-md">{description}</p>
      {ticketRef && (
        <p className="text-slate-600 text-xs mt-3">Tracked in {ticketRef}</p>
      )}
    </div>
  )
}
